import styled from 'styled-components';
import { spacing } from '../../../../styles/helpers';
import { theme } from '../../../../styles/theme';

export const Table = styled.table`
    border: 1px solid #ddd;
    border-collapse: collapse;
    color: ${theme.colors.black};
    width: 100%;

    .bold-text-cell {
        ${theme.typography.h7};
        padding-left: ${spacing['2xs']};
    }
`;

export const Header = styled.th`
  background-color: ${theme.colors.background};
  ${theme.typography.h7};
`;
export const Row = styled.tr`
  background-color: ${theme.colors.white};
  border: ${theme.border.table};
  ${theme.typography.body3};
  height: 36px;
`;
